import React from 'react';
import { FormSelect, FormSelectProps } from 'react-bootstrap';
import styled from 'styled-components';

export const Select = ({
  children,
  ...props
}: React.PropsWithChildren<FormSelectProps>) => (
  <StyledSelect {...props}>{children}</StyledSelect>
);

const StyledSelect = styled(FormSelect)`
  border: none;
  border-radius: 0;
  border-bottom: 1px solid ${(props) => props.theme.color.ui.shade2};
  background: ${(props) => props.theme.color.bg.primary};
  box-shadow: 0px 0px 0px 0px #cbdafc;
  height: 48px;
  width: 100%;
  margin: 0;
  padding: 0;
  font-size: 16px;
  font-family: Montserrat;
  &::placeholder {
    color: ${(props) => props.theme.color.text.disabled};
  }
  &:focus {
    outline: none;
  }
`;
